import { cn, dayjs } from '@/utils';
import React, { memo, useCallback } from 'react';

import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';

import { isNotNilOrEmpty } from 'ramda-adjunct';

export type RangePickerData = {
	dateStrings: string[];
	name: string[];
};

export type RangePickerFormProps = Omit<
	RangePickerProps,
	'name' | 'onChange'
> & {
	name?: string[];
	className?: string;
	startDate?: string;
	endDate?: string;
	onChange?: (data: RangePickerData) => void;

	boxStyle?: React.CSSProperties;
	containerClassName?: string;
};

const { RangePicker } = DatePicker;

const RangePickerForm = ({
	className,
	onChange,
	startDate,
	endDate,
	boxStyle,
	containerClassName,
	name = ['', ''],
	...rest
}: RangePickerFormProps) => {
	const _onChange = useCallback(
		(dates: any, dateStrings: [string, string]) => {
			onChange?.({ dateStrings, name });
		},
		[onChange, name]
	);

	return (
		<div className={containerClassName} style={boxStyle}>
			<RangePicker
				value={
					isNotNilOrEmpty(startDate) && isNotNilOrEmpty(endDate)
						? [dayjs(startDate, 'YYYY-MM-DD'), dayjs(endDate, 'YYYY-MM-DD')]
						: [null, null]
				}
				onChange={_onChange}
				className={cn(
					'bg-transparent !border-none focus:!outline-none !shadow-none p-0 text-xs range-date-input',
					className
				)}
				suffixIcon
				inputReadOnly
				separator={'~'}
				format="YYYY-MM-DD"
				placeholder={['', '']}
				bordered={false}
				size="small"
				{...rest}
			/>
		</div>
	);
};

export default memo(RangePickerForm);
